import React from "react";

import { Props } from "./types";
import icon from "./icon.png";

function BackArrow({ className }: Props) {
  return <img className={className} src={icon} alt="Back Arrow" />;
}

export { BackArrow };
